export function checkCocNumber() {
	function initCocField() {
		const fieldElement = document.querySelector('.coc-number input');

		if (!fieldElement) {
			return;
		}

		const formElement = fieldElement.closest('form');
		const submitButton = formElement ? formElement.querySelector('button[type="submit"], input[type="submit"]') : null;

		// Helper function to control submit button status.
		const toggleSubmitButton = (enable) => {
            if (submitButton) {
                submitButton.disabled = !enable;

                if (!enable) {
                    submitButton.classList.add('disabled-by-coc');
                } else {
                    submitButton.classList.remove('disabled-by-coc');
                }
            }
        };

		// Make sure the button is disabled immediately upon loading.
		toggleSubmitButton(false);

		// Hidden fields.
		const hiddenFields = {
			name: document.querySelector('.company-name input'),
			address: document.querySelector('.company-address input'),
			postal_code: document.querySelector('.company-postal-code input'),
			city: document.querySelector('.company-city input')
		};

		// Input wrapper.
		const wrapper = fieldElement.parentNode.parentNode;

		// Output container.
		let outputContainer = wrapper.querySelector('.coc_output');

		if (!outputContainer) {
			outputContainer = document.createElement('div');
			outputContainer.className = 'coc_output';
			wrapper.appendChild(outputContainer);
		}

		// Helper function to display message en company data.
		const showOutput = (message, status = 'error', company = null) => {
			toggleSubmitButton(status === 'success');

			let html = `<p class="coc_message ${status}">${message}</p>`;

			if (company) {
				html += `
					<ul class="coc_data_display">
						<li><span>Bedrijfsnaam:</span> ${company.name}</li>
						<li><span>Adres:</span> ${company.address}</li>
						<li><span>Postcode:</span> ${company.postal_code}</li>
						<li><span>Plaats:</span> ${company.city}</li>
					</ul>
				`;
			}

			outputContainer.innerHTML = html;
		};

		// Helper function to reset fields.
		const resetHiddenFields = () => {
			Object.values(hiddenFields).forEach(f => f && (f.value = ""));
		};

		// CoC check.
		async function performCocCheck(isAutoRun = false) {
			const cleanCoc = fieldElement.value.replace(/[^0-9]/g, '');

			if (!isAutoRun) {
				resetHiddenFields();
			}

			if (!cleanCoc) {
				showOutput('Je hebt geen geldig KvK-nummer ingevuld.');
				return;
			}

			if (cleanCoc.length !== 8) {
				showOutput('Een KvK-nummer moet uit 8 cijfers bestaan.');
				return;
			}

			if (!isAutoRun) {
				showOutput('We zijn je KvK-nummer aan het controleren.', 'checking');
			}

			// AJAX request
			const formData = new FormData();
			formData.append('action', 'validate_coc_number');
			formData.append('coc_number', cleanCoc);

			try {
				const response = await fetch(levalux_xhr.url, {
					method: 'POST',
					body: formData
				});

				const data = await response.json();

				if (response.ok && data.success) {
					const company = data.data.company_data;

					if (hiddenFields.name) hiddenFields.name.value = company.name;
					if (hiddenFields.address) hiddenFields.address.value = company.address;
					if (hiddenFields.postal_code) hiddenFields.postal_code.value = company.postal_code;
					if (hiddenFields.city) hiddenFields.city.value = company.city;

					showOutput('Bedrijf gevonden', 'success', company);
				} else {
					showOutput(data?.data?.message || 'Technische fout bij controle.');
				}
			} catch (e) {
				showOutput('Er is een netwerkfout opgetreden.');
			}
		}

		// Disable the button once the user starts typing
		fieldElement.addEventListener('input', () => toggleSubmitButton(false));

		fieldElement.addEventListener('blur', () => performCocCheck(false));

		if (fieldElement.value.length > 0) {
			performCocCheck(true);
		}
	}

	initCocField();

	window.addEventListener('gform_post_render', initCocField);
}
